var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"barchart"},[_c('div',{staticClass:"chart"},_vm._l((_vm.details),function(loop,index){return _c('div',{key:`barchart-loop-${index}-${_vm.label}`,staticClass:"bar",style:({
        height: `${_vm.scaledSelector(loop.loop) * 50}px`,
        backgroundColor:
          loop.loop.color != null ? loop.loop.color : loop.protein.color,
      }),on:{"mouseenter":function($event){_vm.setPreview({
          $event,
          description: {
            Protein: loop.protein.name,
            Loop: loop.loop.id,
            Value: _vm.round(_vm.selector(loop.loop), 2),
          },
        })},"mouseleave":function($event){return _vm.setPreview(null)}}},[_c('div',{staticClass:"label",style:({
          marginBottom: `${_vm.clamp(
            _vm.scaledSelector(loop.loop) * 50,
            0,
            100
          )}px`,
        })},[_vm._v(" "+_vm._s(_vm.roundToFourDigits(_vm.selector(loop.loop)))+" ")])])}),0),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }